module.exports = __webpack_public_path__ + "getimgai-2-e564f1a461dc7cea0da35fb2823fc069.webp";